import type { ImportBlocking } from './api/ledger.ts';

/** What still stands in the way of a commit, in words and counts, never a category's text. */
export function blockingWords(b: ImportBlocking, notDuplicatesMarked = 0): string[] {
  const out: string[] = [];
  if (b.unmapped > 0) out.push(`Map every category first: ${b.unmapped} still unmapped`);
  if (b.conflicts > 0) out.push(`${b.conflicts} ${b.conflicts === 1 ? 'line conflicts' : 'lines conflict'} with what is already imported`);
  if (b.refused > 0) out.push(`${b.refused} ${b.refused === 1 ? 'line is' : 'lines are'} refused`);
  if (b.held > 0) out.push(`${b.held} ${b.held === 1 ? 'line is' : 'lines are'} held for a person`);
  const dup = b.duplicates - notDuplicatesMarked;
  if (dup > 0) out.push(`${dup} possible ${dup === 1 ? 'duplicate' : 'duplicates'} of an entry from another source to decide`);
  return out;
}
